import gql from 'graphql-tag';

export const RESET_PASSWORD = gql`
  mutation ($input: ResetPasswordInput!){
    resetPassword(input: $input) {
      status
      message
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/auth/reset.js